/* Add to basket: opAddToCart and the floating tiles end by setting location.href to '#cart'
   (a hash change does not navigate). Refresh and open the theme's cart drawer instead of going to checkout. */
(function () {
  function openCart() {
    if (window.location.hash !== '#cart') return;
    if (window.history && window.history.replaceState) window.history.replaceState(null, '', window.location.pathname + window.location.search);
    document.querySelectorAll('.op-btn-primary, .op-btn-secondary').forEach(function (b) { b.disabled = false; b.style.opacity = ''; });
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') { window.location.href = '/cart'; return; }
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents({ sections: sections });
      })
      .catch(function () { window.location.href = '/cart'; });
  }
  window.addEventListener('hashchange', openCart);
  openCart();
})();
